import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { createActions, createReducer } from "reduxsauce"

import { COMPARE_IDS } from "../../Components/Filters/CompareSelect/presets"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getHealthMainInfoRequest: ["payload"],
  getHealthMainInfoSuccess: ["payload"],
  getHealthMainInfoFailure: ["payload"],

  getHealthOverviewRequest: ["payload"],
  getHealthOverviewSuccess: ["payload"],
  getHealthOverviewFailure: ["payload"],

  getPreventionRateRequest: ["payload"],
  getPreventionRateSuccess: ["payload"],
  getPreventionRateFailure: ["payload"],

  getDataByCardTypeRequest: ["payload"],
  getDataByCardTypeSuccess: ["payload"],
  getDataByCardTypeFailure: ["payload"],

  getDataByCountryRequest: ["payload"],
  getDataByCountrySuccess: ["payload"],
  getDataByCountryFailure: ["payload"],

  getDataByReasonCodeRequest: ["payload"],
  getDataByReasonCodeSuccess: ["payload"],
  getDataByReasonCodeFailure: ["payload"],

  getDataOlympicsRequest: ["payload"],
  getDataOlympicsSuccess: ["payload"],
  getDataOlympicsFailure: ["payload"],

  getRiskLevelRequest: ["payload"],
  getRiskLevelSuccess: ["payload"],
  getRiskLevelFailure: ["payload"],

  getFilterOptionsRequest: ["payload"],
  getFilterOptionsSuccess: ["payload"],
  getFilterOptionsFailure: null,

  getVampMainChartRequest: ["payload"],
  getVampMainChartSuccess: ["payload"],
  getVampMainChartFailure: null,

  getVampMonitoringProgramChartRequest: ["payload"],
  getVampMonitoringProgramChartSuccess: ["payload"],
  getVampMonitoringProgramChartFailure: null,

  getVampEstimatedProgramStatusRequest: ["payload"],
  getVampEstimatedProgramStatusSuccess: ["payload"],
  getVampEstimatedProgramStatusFailure: null,

  getMcMainChartRequest: ["payload"],
  getMcMainChartSuccess: ["payload"],
  getMcMainChartFailure: null,

  getMcMonitoringProgramChartRequest: ["payload"],
  getMcMonitoringProgramChartSuccess: ["payload"],
  getMcMonitoringProgramChartFailure: null,

  getEfmMonitoringProgramChartRequest: ["payload"],
  getEfmMonitoringProgramChartSuccess: ["payload"],
  getEfmMonitoringProgramChartFailure: null,

  getMcEstimatedProgramStatusRequest: ["payload"],
  getMcEstimatedProgramStatusSuccess: ["payload"],
  getMcEstimatedProgramStatusFailure: null,

  monitoringInit: ["payload"],
  monitoringInitSuccess: ["payload"],
  monitoringInitFailure: ["payload"],

  createVampEnrollmentRequest: ["payload"],
  createVampEnrollmentSuccess: ["payload"],
  createVampEnrollmentFailure: ["payload"],

  healthSetProp: ["key", "value"],

  logout: null
})

export const HealthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  fetching: false,
  mainInfo: {
    is_business_health_available: false,
    warning_notification: null, // "missing_stripe_connection" | "missing_stripe_permissions" |"report_in_progress"
    prevention_rate: 0,
    chargeback_rate: 0,
    chargeback_count: 0,
    chargeback_rate_without_us: 0,
    chargeback_count_without_us: 0,
    data_blocks: [
      {
        title: "Chargebacks prevented",
        tooltip: null,
        value: 0
      },
      {
        title: "Chargeback rate",
        tooltip: null,
        value: 0,
        suffix: "%",
        precision: 2
      },
      {
        title: "Prevention rate",
        tooltip: null,
        value: 0,
        suffix: "%",
        precision: 2
      },
      {
        title: "Chargeback fees saved",
        tooltip: null,
        value: 0,
        prefix: "$",
        precision: 2
      }
    ],
    filter_options: {
      years: []
    }
  },
  result: null,
  errors: false,

  preventionRateFetching: false,
  preventionRateData: [
    { month: "JAN", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "FEB", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "MAR", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "APR", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "MAY", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "JUN", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "JUL", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "AUG", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "SEP", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "OCT", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "NOV", preventionRate: 0, disputes_count: 0, alerts_count: 0 },
    { month: "DEC", preventionRate: 0, disputes_count: 0, alerts_count: 0 }
  ],
  preventionRateYear: 2025,

  dataByCardTypeFetching: false,
  dataByCardType: {
    result: [],
    summary: {
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0,
      chargeback_rate_without_us: 0,
      prevention_rate: 0
    }
  },

  selectCountries: [],
  dataByCountryFetching: false,
  dataByCountry: {
    count: 0,
    result: [],
    summary: {
      transactions_count: 0,
      transactions_amount: 0,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      alerts_count: 0,
      alerts_amount: 0,
      chargeback_rate: 0,
      chargeback_rate_without_us: 0,
      prevention_rate: 0
    }
  },

  selectCards: [],
  dataByReasonCodeFetching: false,
  dataByReasonCode: {
    count: 0,
    result: [],
    summary: {
      type: null,
      chargebacks_count: 0,
      chargebacks_amount: 0,
      chargebacks_without_us_count: 0,
      chargebacks_without_us_amount: 0,
      alerts_count: 0,
      alerts_amount: 0,
      prevention_rate: 0
    }
  },

  dataOlympicsFetching: false,
  dataOlympics: {
    count: 0,
    results: []
  },

  overviewFetching: false,
  overview: {
    labels: [],
    result: {
      with_us: [],
      without_us: []
    }
  },

  riskLevelFetching: false,
  riskLevel: 0,

  filtersLastUpd: null,
  filters: {
    period: "27 days",
    overviewType: "rate", // 'count' | 'rate'
    compare: { mode: COMPARE_IDS.PREV_PERIOD },
    lastCompare: null
  },

  filterOptions: {
    years: [],
    card_brand: []
  },

  vampMainChart: null,
  vampMainChartFetching: false,

  vampMonitoringProgramChart: null,
  vampMonitoringProgramChartFetching: false,

  mcMainChart: null,
  mcMainChartFetching: false,

  mcMonitoringProgramChart: null,
  mcMonitoringProgramChartFetching: false,

  efmMonitoringProgramChart: null,
  efmMonitoringProgramChartFetching: false,

  mcEstimatedProgramStatus: null,
  mcEstimatedProgramStatusFetching: false,

  vampEstimatedProgramStatus: null,
  vampEstimatedProgramStatusFetching: false,

  monitoringInitialized: false,
  monitoringInitializing: true,
  monitoringInitError: null,

  descriptorsList: [],
  descriptor: null,
  showEnrollmentModal: false,
  isHistoricalDataMode: false,
  enrollmentData: null,

  vampEnrollmentRequestLoading: false,

  dataSource: "stripe" // 'stripe' | 'shopify'
}

/* ------------- Functions for reducer cases ------------- */

const getHealthMainInfoRequest = (state) => ({ ...state, fetching: true })
const getHealthMainInfoSuccess = (state, { payload: mainInfo }) => ({
  ...state,
  fetching: false,
  mainInfo
})
const getHealthMainInfoFailure = (state) => ({ ...state, fetching: false })

const getHealthOverviewRequest = (state) => ({
  ...state,
  overviewFetching: true
})
const getHealthOverviewSuccess = (state, { payload: overview }) => ({
  ...state,
  overviewFetching: false,
  overview
})
const getHealthOverviewFailure = (state) => ({
  ...state,
  overviewFetching: false
})

const getPreventionRateRequest = (state) => ({
  ...state,
  preventionRateFetching: true
})
const getPreventionRateSuccess = (state, { payload: preventionRateData }) => ({
  ...state,
  preventionRateFetching: false,
  preventionRateData
})
const getPreventionRateFailure = (state) => ({
  ...state,
  preventionRateFetching: false
})

const getDataByCardTypeRequest = (state) => ({
  ...state,
  dataByCardTypeFetching: true
})
const getDataByCardTypeSuccess = (state, { payload: dataByCardType }) => ({
  ...state,
  dataByCardTypeFetching: false,
  dataByCardType
})
const getDataByCardTypeFailure = (state) => ({
  ...state,
  dataByCardTypeFetching: false
})

const getDataByCountryRequest = (state) => ({
  ...state,
  dataByCountryFetching: true
})
const getDataByCountrySuccess = (state, { payload: dataByCountry }) => ({
  ...state,
  dataByCountryFetching: false,
  dataByCountry
})
const getDataByCountryFailure = (state) => ({
  ...state,
  dataByCountryFetching: false
})

const getDataByReasonCodeRequest = (state) => ({
  ...state,
  dataByReasonCodeFetching: true
})
const getDataByReasonCodeSuccess = (state, { payload: dataByReasonCode }) => ({
  ...state,
  dataByReasonCodeFetching: false,
  dataByReasonCode
})
const getDataByReasonCodeFailure = (state) => ({
  ...state,
  dataByReasonCodeFetching: false
})

const getDataOlympicsRequest = (state) => ({
  ...state,
  dataOlympicsFetching: true
})
const getDataOlympicsSuccess = (state, { payload: dataOlympics }) => ({
  ...state,
  dataOlympicsFetching: false,
  dataOlympics
})
const getDataOlympicsFailure = (state) => ({
  ...state,
  dataOlympicsFetching: false
})

const getRiskLevelRequest = (state) => ({ ...state, riskLevelFetching: true })
const getRiskLevelSuccess = (state, { payload }) => ({
  ...state,
  riskLevelFetching: false,
  riskLevel: payload?.["risk_level"] || 0
})
const getRiskLevelFailure = (state) => ({ ...state, riskLevelFetching: false })

const getFilterOptionsRequest = (state) => state
const getFilterOptionsSuccess = (state, { payload: filterOptions }) => ({
  ...state,
  filterOptions
})
const getFilterOptionsFailure = (state) => state

const getVampMainChartRequest = (state) => ({
  ...state,
  vampMainChartFetching: true
})
const getVampMainChartSuccess = (state, { payload: vampMainChart }) => ({
  ...state,
  vampMainChartFetching: false,
  vampMainChart
})
const getVampMainChartFailure = (state) => ({
  ...state,
  vampMainChartFetching: false
})

const getMcMainChartRequest = (state) => ({
  ...state,
  mcMainChartFetching: true,
});
const getMcMainChartSuccess = (state, { payload: mcMainChart }) => ({
  ...state,
  mcMainChartFetching: false,
  mcMainChart,
});
const getMcMainChartFailure = (state) => ({
  ...state,
  mcMainChartFetching: false,
});

const getMcMonitoringProgramChartRequest = (state) => ({
  ...state,
  mcMonitoringProgramChartFetching: true,
});
const getMcMonitoringProgramChartSuccess = (state, { payload: mcMonitoringProgramChart }) => ({
  ...state,
  mcMonitoringProgramChartFetching: false,
  mcMonitoringProgramChart,
});
const getMcMonitoringProgramChartFailure = (state) => ({
  ...state,
  mcMonitoringProgramChartFetching: false,
});

const getEfmMonitoringProgramChartRequest = (state) => ({
  ...state,
  efmMonitoringProgramChartFetching: true,
});
const getEfmMonitoringProgramChartSuccess = (state, { payload: efmMonitoringProgramChart }) => ({
  ...state,
  efmMonitoringProgramChartFetching: false,
  efmMonitoringProgramChart,
});
const getEfmMonitoringProgramChartFailure = (state) => ({
  ...state,
  efmMonitoringProgramChartFetching: false,
});

const getMcEstimatedProgramStatusRequest = (state) => ({
  ...state,
  mcEstimatedProgramStatusFetching: true,
});
const getMcEstimatedProgramStatusSuccess = (state, { payload: mcEstimatedProgramStatus }) => ({
  ...state,
  mcEstimatedProgramStatusFetching: false,
  mcEstimatedProgramStatus,
});
const getMcEstimatedProgramStatusFailure = (state) => ({
  ...state,
  mcEstimatedProgramStatusFetching: false,
});

const getVampMonitoringProgramChartRequest = (state) => ({
  ...state,
  vampMonitoringProgramChartFetching: true
})
const getVampMonitoringProgramChartSuccess = (state, { payload: vampMonitoringProgramChart }) => ({
  ...state,
  vampMonitoringProgramChartFetching: false,
  vampMonitoringProgramChart
})
const getVampMonitoringProgramChartFailure = (state) => ({
  ...state,
  vampMonitoringProgramChartFetching: false
})

const getVampEstimatedProgramStatusRequest = (state) => ({
  ...state,
  vampEstimatedProgramStatusFetching: true
})
const getVampEstimatedProgramStatusSuccess = (state, { payload: vampEstimatedProgramStatus }) => ({
  ...state,
  vampEstimatedProgramStatusFetching: false,
  vampEstimatedProgramStatus
})
const getVampEstimatedProgramStatusFailure = (state) => ({
  ...state,
  vampEstimatedProgramStatusFetching: false
})

const monitoringInit = (state) => ({ ...state, monitoringInitializing: true })
const monitoringInitSuccess = (state, { payload }) => {
  let { descriptorsList, enrollmentData } = payload || {}
  descriptorsList = descriptorsList.map((desc) => desc?.[0]).filter(Boolean) || []

  return {
    ...state,
    monitoringInitializing: false,
    monitoringInitialized: true,
    descriptorsList,
    descriptor: descriptorsList?.[0] || null,
    enrollmentData: enrollmentData || null,
    isHistoricalDataMode: enrollmentData?.historical_data_available
      ? state.isHistoricalDataMode
      : false
  }
}

const monitoringInitFailure = (state, { payload: error }) => ({
  ...state,
  monitoringInitializing: false,
  monitoringInitError: error
})

const createVampEnrollmentRequest = (state) => {
  return {
    ...state,
    vampEnrollmentRequestLoading: true
  }
}

const createVampEnrollmentSuccess = (state, { payload }) => {
  return {
    ...state,
    vampEnrollmentRequestLoading: false
  }
}

const createVampEnrollmentFailure = (state, { payload: error }) => {
  return {
    ...state,
    vampEnrollmentRequestLoading: false
  }
}

export const healthSetProp = (state, { key, value }) => {
  const obj = {}
  if (key === "filters") {
    obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state.filters, ...value }
  } else {
    obj[key] = value
  }
  return { ...state, ...obj }
}

const logout = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_HEALTH_MAIN_INFO_REQUEST]: getHealthMainInfoRequest,
  [Types.GET_HEALTH_MAIN_INFO_SUCCESS]: getHealthMainInfoSuccess,
  [Types.GET_HEALTH_MAIN_INFO_FAILURE]: getHealthMainInfoFailure,

  [Types.GET_HEALTH_OVERVIEW_REQUEST]: getHealthOverviewRequest,
  [Types.GET_HEALTH_OVERVIEW_SUCCESS]: getHealthOverviewSuccess,
  [Types.GET_HEALTH_OVERVIEW_FAILURE]: getHealthOverviewFailure,

  [Types.GET_PREVENTION_RATE_REQUEST]: getPreventionRateRequest,
  [Types.GET_PREVENTION_RATE_SUCCESS]: getPreventionRateSuccess,
  [Types.GET_PREVENTION_RATE_FAILURE]: getPreventionRateFailure,

  [Types.GET_DATA_BY_CARD_TYPE_REQUEST]: getDataByCardTypeRequest,
  [Types.GET_DATA_BY_CARD_TYPE_SUCCESS]: getDataByCardTypeSuccess,
  [Types.GET_DATA_BY_CARD_TYPE_FAILURE]: getDataByCardTypeFailure,

  [Types.GET_DATA_BY_COUNTRY_REQUEST]: getDataByCountryRequest,
  [Types.GET_DATA_BY_COUNTRY_SUCCESS]: getDataByCountrySuccess,
  [Types.GET_DATA_BY_COUNTRY_FAILURE]: getDataByCountryFailure,

  [Types.GET_DATA_BY_REASON_CODE_REQUEST]: getDataByReasonCodeRequest,
  [Types.GET_DATA_BY_REASON_CODE_SUCCESS]: getDataByReasonCodeSuccess,
  [Types.GET_DATA_BY_REASON_CODE_FAILURE]: getDataByReasonCodeFailure,

  [Types.GET_DATA_OLYMPICS_REQUEST]: getDataOlympicsRequest,
  [Types.GET_DATA_OLYMPICS_SUCCESS]: getDataOlympicsSuccess,
  [Types.GET_DATA_OLYMPICS_FAILURE]: getDataOlympicsFailure,

  [Types.GET_RISK_LEVEL_REQUEST]: getRiskLevelRequest,
  [Types.GET_RISK_LEVEL_SUCCESS]: getRiskLevelSuccess,
  [Types.GET_RISK_LEVEL_FAILURE]: getRiskLevelFailure,

  [Types.GET_FILTER_OPTIONS_REQUEST]: getFilterOptionsRequest,
  [Types.GET_FILTER_OPTIONS_SUCCESS]: getFilterOptionsSuccess,
  [Types.GET_FILTER_OPTIONS_FAILURE]: getFilterOptionsFailure,

  [Types.GET_VAMP_MAIN_CHART_REQUEST]: getVampMainChartRequest,
  [Types.GET_VAMP_MAIN_CHART_SUCCESS]: getVampMainChartSuccess,
  [Types.GET_VAMP_MAIN_CHART_FAILURE]: getVampMainChartFailure,

  [Types.GET_MC_MAIN_CHART_REQUEST]: getMcMainChartRequest,
  [Types.GET_MC_MAIN_CHART_SUCCESS]: getMcMainChartSuccess,
  [Types.GET_MC_MAIN_CHART_FAILURE]: getMcMainChartFailure,

  [Types.GET_MC_MONITORING_PROGRAM_CHART_REQUEST]: getMcMonitoringProgramChartRequest,
  [Types.GET_MC_MONITORING_PROGRAM_CHART_SUCCESS]: getMcMonitoringProgramChartSuccess,
  [Types.GET_MC_MONITORING_PROGRAM_CHART_FAILURE]: getMcMonitoringProgramChartFailure,

  [Types.GET_EFM_MONITORING_PROGRAM_CHART_REQUEST]: getEfmMonitoringProgramChartRequest,
  [Types.GET_EFM_MONITORING_PROGRAM_CHART_SUCCESS]: getEfmMonitoringProgramChartSuccess,
  [Types.GET_EFM_MONITORING_PROGRAM_CHART_FAILURE]: getEfmMonitoringProgramChartFailure,

  [Types.GET_MC_ESTIMATED_PROGRAM_STATUS_REQUEST]: getMcEstimatedProgramStatusRequest,
  [Types.GET_MC_ESTIMATED_PROGRAM_STATUS_SUCCESS]: getMcEstimatedProgramStatusSuccess,
  [Types.GET_MC_ESTIMATED_PROGRAM_STATUS_FAILURE]: getMcEstimatedProgramStatusFailure,

  [Types.GET_VAMP_MONITORING_PROGRAM_CHART_REQUEST]: getVampMonitoringProgramChartRequest,
  [Types.GET_VAMP_MONITORING_PROGRAM_CHART_SUCCESS]: getVampMonitoringProgramChartSuccess,
  [Types.GET_VAMP_MONITORING_PROGRAM_CHART_FAILURE]: getVampMonitoringProgramChartFailure,

  [Types.GET_VAMP_ESTIMATED_PROGRAM_STATUS_REQUEST]: getVampEstimatedProgramStatusRequest,
  [Types.GET_VAMP_ESTIMATED_PROGRAM_STATUS_SUCCESS]: getVampEstimatedProgramStatusSuccess,
  [Types.GET_VAMP_ESTIMATED_PROGRAM_STATUS_FAILURE]: getVampEstimatedProgramStatusFailure,

  [Types.MONITORING_INIT]: monitoringInit,
  [Types.MONITORING_INIT_SUCCESS]: monitoringInitSuccess,
  [Types.MONITORING_INIT_FAILURE]: monitoringInitFailure,

  [Types.CREATE_VAMP_ENROLLMENT_REQUEST]: createVampEnrollmentRequest,
  [Types.CREATE_VAMP_ENROLLMENT_SUCCESS]: createVampEnrollmentSuccess,
  [Types.CREATE_VAMP_ENROLLMENT_FAILURE]: createVampEnrollmentFailure,

  [Types.HEALTH_SET_PROP]: healthSetProp,

  [Types.LOGOUT]: logout
})


const PERSISTED_REDUCER_VERSION = 10;

export const persistedReducer = persistReducer(
  {
    key: "health",
    storage,
    whitelist: [
      "filters",
      "filterOptions",
      "filtersLastUpd",
      "dataSource",
      "preventionRateYear",
      "isHistoricalDataMode",
    ],
    version: PERSISTED_REDUCER_VERSION,
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          ...INITIAL_STATE,
        };
      }
      return state;
    },
  },
  reducer
)
